import { CSSProperties } from "react";
import styles from "./index.module.css";
import { Form, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { CustomButton } from "Components/CustomButton";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  buttons: {
    confirm: {
      className?: string;
      style?: CSSProperties;
      label: string;
      onConfirm: () => void;
      isDanger?: boolean;
      loading?: boolean;
    };
    decline: {
      className?: string;
      style?: CSSProperties;
      label: string;
      onDecline: () => void;
      isDanger?: boolean;
    };
  };
  content: string | React.ReactElement;
  inputField?: {
    onChange: (text: string) => void;
  };
  /** Заменяет стандартную пару кнопок confirm/decline */
  footer?: React.ReactElement;
};

type FieldType = {
  comment: string;
};
export const ModalComponent = ({ isOpen, onClose, title, buttons, inputField, content, footer }: Props) => {
  const [form] = Form.useForm<FieldType>();

  const onFinish = (values) => {
    if (values) {
      if (inputField) inputField.onChange(values.textArea);
      buttons.confirm.onConfirm();
      onClose();
      form.resetFields();
    }
  };
  return (
    <div className={styles.wrapperModal}>
      <Modal
        className={styles.modal}
        title={title}
        footer={false}
        onCancel={onClose}
        open={isOpen}
        closeIcon={<CloseOutlined style={{ fontSize: 14, color: "#000" }} />}
      >
        <div className={styles.content} style={!inputField ? { marginBottom: 45, marginTop: 45 } : null}>
          {content}
        </div>
        <Form form={form} onFinish={onFinish} autoComplete="off">
          {inputField && (
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Field must not be empty",
                },
              ]}
              style={{ marginBottom: 48 }}
              name="textArea"
            >
              <TextArea onChange={(e) => inputField.onChange(e.target.value)} className={styles.inputArea} />
            </Form.Item>
          )}
          <div className={styles.btnWrapper}>
            {footer ?? (
              <>
                <CustomButton
                  typeButton={buttons.decline.isDanger ? "critical" : "tertiary"}
                  sizeButton="large"
                  style={buttons.decline.style}
                  onClick={() => buttons.decline.onDecline()}
                  htmlType="reset"
                  danger={buttons.decline.isDanger}
                >
                  {buttons.decline.label}
                </CustomButton>
                <CustomButton
                  sizeButton="large"
                  typeButton={buttons.confirm.isDanger ? "critical" : "primary"}
                  style={buttons.confirm.style}
                  htmlType="submit"
                  danger={buttons.confirm.isDanger}
                  loading={buttons.confirm.loading}
                >
                  {buttons.confirm.label}
                </CustomButton>
              </>
            )}
          </div>
        </Form>
      </Modal>
    </div>
  );
};
